import { Button, Grid, Typography } from '@mui/material'
import axios from 'axios';
import React, { useState } from 'react'
import { Circles } from 'react-loader-spinner'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useTitleContext } from '../../Context/TitleContext';
import CustomToast from '../CustomToast/CustomToast';

const Header = () => {

    const { title } = useTitleContext();


    return (
        <>
            <Grid position={'relative'} width={'100%'} height={'70px'} bgcolor={'#2b3245'} p={{ xs: '8px', md: '16px' }} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                <Grid display={'flex'} alignItems={'center'} gap={{ xs: '4px', md: '8px' }}>
                    <Grid width={'60px'} height={'60px'} bgcolor={'transparent'} display={'flex'} alignItems={'center'} justifyContent={'center'} borderRadius={'4px'}>
                        <img src='/assets/images/AltynLogo.svg' alt='' style={{ width: '70%', height: '70%' }} />
                    </Grid>
                </Grid>
                <Grid position={'absolute'} className='center-position-fill-form'>
                    <Typography variant='h2' color={'white'} fontWeight={700}>{title}</Typography>
                </Grid>
            </Grid>
        </>
    )
}

export default Header